module.exports = __webpack_public_path__ + "c90cf0544d4b2dfc89febebf2c4dffbc.svg";